const isValidUrl = input => {
  const pattern =
    /\(?(?:(http:\/\/|https:\/\/))(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^s\?\n]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.){1})|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/g

  return pattern.test(input)
}

const validate = values => {
  const urlErrorMsg =
    "The link is invalid! It must include both http:// or https:// and a suffix like .com"
  const errors = {}
  if (!values.first_name) {
    errors.first_name = "Required"
  }
  if (!values.last_name) {
    errors.last_name = "Required"
  }
  if (!values.email) {
    errors.email = "Required"
  }
  if (values.fb_link && !isValidUrl(values.fb_link)) {
    errors.fb_link = urlErrorMsg
  }
  if (values.insta_link && !isValidUrl(values.insta_link)) {
    errors.insta_link = urlErrorMsg
  }
  if (values.tw_link && !isValidUrl(values.tw_link)) {
    errors.tw_link = urlErrorMsg
  }
  if (values.linkedin_link && !isValidUrl(values.linkedin_link)) {
    errors.linkedin_link = urlErrorMsg
  }
  if (values.pinterest_link && !isValidUrl(values.pinterest_link)) {
    errors.pinterest_link = urlErrorMsg
  }
  if (values.yt_link && !isValidUrl(values.yt_link)) {
    errors.yt_link = urlErrorMsg
  }
  if (values.tiktok_link && !isValidUrl(values.tiktok_link)) {
    errors.tiktok_link = urlErrorMsg
  }
  return errors
}

export default validate
